<template>
    <div style="display: flex; flex-direction: column; background-color: #fffc; backdrop-filter: blur(100px);">
        <Transition name="fade">
            <div v-if="isShowBackgroundImage" ref="background_image" class="background_image_wrapper" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%;"></div>
        </Transition>
        <MercenaryHeader :isBlur="true" backgroundColor="#fffc" :title="'요청서 리포트'" :back-title="'뒤로가기'" :close-action="closeAction"></MercenaryHeader>
        <div v-if="reportList.length > 0" style="font-size: 12px; font-weight: 400; color: #606060; margin-top: 20px; padding-left: 12px; padding-bottom: 8px;">눌러서 상세 정보를 확인할 수 있습니다.</div>
        <div style="flex: 1; padding: 12px; overflow-y: hidden;">
            <template v-if="reportList.length > 0">
                <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle" style="height: 100%;">
                    <div v-for="each, i in reportList" style="" :key="i">
                        <div style="display: flex; gap: 4px; align-items: center;">
                            <img style="width: 12px;" :src="require('@/assets/img/direct_message.png')" alt="">
                            <div style="font-weight: 500; line-height: 24px; margin-bottom: 4px;">{{ each.team ? each.team.name : '' }}, {{ each.to_member.nic_name }}</div>
                        </div>
                        <div style="display: flex; gap: 4px; align-items: center; margin-bottom: 16px;">
                            <img style="width: 8px;" :src="require('@/assets/img/check_gray.png')" alt="">
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">요청서 전달됨</div>
                        </div>
                        <div v-if="each.soccerhow" style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px; padding: 12px;">
                            <CommonPost :hideOption="true" :isReportList="true" :soccerHows="each.soccerhow"></CommonPost>
                        </div>
                        <div @click="showMyReport(each.soccerhow.idx, each.idx); $Util.sendEventClick('사커하우_요청서리포트_자세히보기')" style="margin-top: 16px; display: flex; gap: 4px; align-items: center;">
                            <img style="width: 20px;" :src="require('@/assets/img/show_report.png')" alt="">
                            <div style="font-weight: 700; font-size: 14px; line-height: 24px; color: var(--color-main);">요청서 리포트 보기</div>
                            <img style="width: 10px;" :src="require('@/assets/img/arrow_main_color.png')" alt="">
                        </div>
                        <div style="height: 1px; background: #210F031A; margin: 44px 0;"></div>
                    </div>
                </InfinityScroll>
            </template>
            <template v-else>
                <div style="display: flex; flex-direction: column; height: 100%; justify-content: center; align-items: center;">
                    <div style="font-weight: 400; font-size: 14px; line-height: 20px; margin-bottom: 4px;">보낸 다이렉트 요청서가 없습니다.</div>
                    <div @click="confirmMySoccerhow" style="font-size: 14px; font-weight: 500; line-height: 20px; color: #5c9dff;">다이렉트 요청서 보내기</div>
                </div>
            </template>
        </div>
        <BookmarkPopup :height="254" :isShowBookmarkPopup="isShowRequestConfirmPopup" :closeBookmarkPopup="closeRequestConfirmPopup">
            <div>
                <div @click="closeRequestConfirmPopup" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;">만들어둔 입단 요청서가 없어요<br>새로 만들어야 해요</div>
                <div @click="showRequestJoinForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">입단 요청서 만들기</div>
            </div>
        </BookmarkPopup>
        <MakeRequestJoinForm :soccerhowIdx="soccerhowIdx" :isFromReportList="isFromReportList" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        <CommonPopupFrame :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowRequestForm" :closeCompleteAction="closeRequestForm">
            <div @click="closeRequestForm" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                <div style="text-align: center; margin-top: 60px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 요청서를 전달할게요</div>
                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(requestInfo).length > 0">
                    <CommonPost :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="requestInfo"></CommonPost>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div @click="sendRequestForm" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import InfinityScroll from '@/components/common/InfinityScroll'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import {SOCCER_HOW_TYPE} from '@/Constants'
import MakeRequestJoinForm from "@/components/soccerhowmain/MakeRequestJoinForm";
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'RequestReportDetail',
    components: { MercenaryHeader, MakeRequestJoinForm, CommonPost, InfinityScroll, BookmarkPopup, CommonPopupFrame },
    props: {

    },
    created() {
        this.getMyReportList()
        setTimeout(() => {
            this.isShowBackgroundImage = true
            this.setBackgroundImage()
        }, 500)
    },
    data() {
        return {
            reportList: [],
            page: 1,
            isEnableNextPageHandle: true,
            isShowRequestConfirmPopup: false,
            isShowMakeRequestJoinForm: false,
            requestInfo: {},
            isShowRequestForm: false,
            isFromReportList: false,
            soccerhowIdx: -1,
            isShowBackgroundImage: false
        }
    },
    methods: {
        closeAction() {
            this.isShowBackgroundImage = false
            setTimeout(() => {
                this.$GlobalStore.closeLastModal()
            })
        },
        sendRequestForm() {
            this.soccerhowIdx = this.requestInfo.idx
            this.isShowRequestForm = false
            this.isShowMakeRequestJoinForm = true
            this.isFromReportList = true
        },
        closeRequestForm() {
            this.isShowRequestForm = false
            this.isFromReportList = false
        },
        async confirmMySoccerhow() {
            const parameters = {}
            const types = [SOCCER_HOW_TYPE.SC_COUNSEL, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_JOB]
            parameters.types = types

            const res = await this.$Axios.get('/api/soccerhow/mine', { params: parameters })
            if (res.data.soccerhows.length === 0) {
                this.isShowRequestConfirmPopup = true
            } else {
                this.requestInfo = res.data.soccerhows[0]
                this.isShowRequestForm = true
            }
        },
        showRequestJoinForm() {
            this.closeRequestConfirmPopup()
            this.isShowMakeRequestJoinForm = true
        },
        setIsShowRequestConfirmPopup() {
            this.isShowRequestConfirmPopup = true;
        },
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false;
        },
        closeRequestConfirmPopup() {
            this.isShowRequestConfirmPopup = false;
        },
        showMyReport(idx, direct_message_idx) {
            this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: idx, direct_message_idx : direct_message_idx})
        },
        async getMyReportList() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            const res = await this.$Axios.get('/api/soccerhow/reporting/list', { params: parameters })

            const reportList = res.data.direct_messages

            if (reportList.length > 0) {
                this.isEnableNextPageHandle = true
                this.reportList = [...this.reportList, ...reportList]
            }
        },
        refresh() {
            this.reportList = []
            this.page = 1
            this.getMyReportList()
        },
        handleNextPage() {
            this.page++
            this.getMyReportList()
        },
        setBackgroundImage() {
            this.$nextTick(() => {
                const imageUrl = this.$resourcePath + this.$GlobalStore.loginInfo().image_path
                this.$refs.background_image.style.backgroundImage = `url('${imageUrl}')`;
            })
        }
    }
}
</script>

<style scoped>
.background_image_wrapper {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    z-index: -1;
    opacity: 0.2;
    filter: blur(100px);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to

    {
    opacity: 0;
}
</style>